<template>
  <div >
    <Wp_image :url="activityImage" :radius="5" v-if="activityImage && activityImage.length>1"/>
    <div class="cell_title">
      <div v-html="linkContent"/>
    </div>
  </div>
</template>
<script>
import Wp_image from '../custom/Wp_image'

export default {
  components: { Wp_image },
  props: {
    item: {}
  },
  watch: {
    item: {
      handler (newV, oldV) {
        if (newV) {
          this.activityItem = newV
          this.getImage()
          this.makeLinkContent()
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      linkContent: '',
      activityImage: '',
      activityItem: {},
    }
  },
  methods: {
    getImage () {
      if (this.activityItem) {
        this.activityImage = this.$union_utils.getActivityImage(this.item.imgList, '350*350')
      }else{
        this.activityImage=''
      }
    },
    getActTime () {
      if (this.activityItem) {
        let endTime = new Date(this.activityItem.endTime)
        let startTime = new Date(this.activityItem.startTime)
        return this.$common.dateFmt('yyyy.MM.dd', startTime) + '-' + this.$common.dateFmt('yyyy.MM.dd', endTime)
      }
    },
    makeLinkContent () {
      if (this.activityItem) {
        this.linkContent = this.activityItem.title + '<br/>'
        if(this.activityItem.advantage) {
          this.linkContent = this.linkContent + this.activityItem.advantage + '<br/>'
          this.linkContent = this.linkContent + '活动时间:' + this.getActTime() + '<br/>'
        }
      }
      return this.linkContent
    },
  }
}
</script>
<style>
.cell_title {
  font-size: 13px;
  font-weight: bold;
}
</style>